// ── Height storage helpers ─────────────────────────────────────────────────────
// Height collection UI now lives as a phase of the main modal (views/height.ts);
// this file only persists the user's height.

import { storage, STORAGE_KEYS } from '../utils/storage';

export function getStoredHeightIn(): string | null {
  return storage.get(STORAGE_KEYS.USER_HEIGHT_IN);
}

export function storeHeightIn(inches: string): void {
  storage.set(STORAGE_KEYS.USER_HEIGHT_IN, inches);
}

export function getStoredHeightCm(): number | null {
  const raw = getStoredHeightIn();
  if (!raw) return null;
  const n = Number(raw);
  if (!n || n < 39 || n > 91) return null;
  return Math.round(n * 2.54);
}
